import React, { Component } from "react";
import { FileDownload, TrendingUp } from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  Tooltip,
} from "@mui/material";
import moment from "moment";
import { connect } from "react-redux";

import { getSMSDetails } from "../../actions/sms";
import {
  getSMSHistory,
  getSMSReportSync,
  getSmartStatusSMSHistory,
  getStatusSMSHistory,
  getTrackCampaignDelivery,
} from "../../actions/smsHistory";
import Table from "../../components/Table";
import { GAEventTracker } from "../../lib/googleAnalytics";
import { formatTimestampMs } from "../../lib/utils";
import Filter from "./Filter";
import SmartSmsReport from "./smartSmsReport";
import SmsReport from "./smsReport";
import TrackCampaign from "./trackCampaign";

// Matches the page size the table offers by default. Sent to the server as
// page_size — before 2026-09-09 nothing was sent, the server defaulted to 50,
// and the picker still read 100.
const DEFAULT_PAGE_SIZE = 100;

class SmsHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      smsList: [],
      showAllContacts: false,
      showAllSmartContacts: false,
      showContactsList: [],
      showWait: false,
      anchorEl: null,
      activeyTrackCampaign: null,
      showTrackData: false,
      excelData: [],
      currentPage: 0,
      pageSize: DEFAULT_PAGE_SIZE,
      totalCount: 0,
      smsDetails:
        props.smsDetails && props.smsDetails.success
          ? props.smsDetails.data
          : {},
    };
    // Filter params of the last query, replayed on every page change so paging
    // keeps the user's date range / headers / SMS type.
    this.lastQueryParams = null;
    this.orgSMSList = [];
    this.receivedHistory = null;
    this.receiveSingleHistory = true;
    this.receiveSingleSmartHistory = true;
    this.receiveTrackCampaign = true;
    this.receiveReport = false;
    this.receivedSMSDetails = null;
    this.singleHistory = [];
    this.singleSmartHistory = [];
    this.activeTrackData = null;
    this.smsTypeFilter = "ALL";
    this.filterApplied = false;
  }
  componentDidMount() {
    if (!this.state.smsDetails.senderIds) {
      this.receivedSMSDetails = false;
      this.props.getSMSDetails();
    } else {
      this.receivedSMSDetails = true;
      const params = {
        endDate: moment().valueOf(),
        startDate: moment().subtract(1, "months").valueOf(),
        senderId: this.state.smsDetails.senderIds,
      };
      this.fetchHistory(params);
    }
  }

  // Single entry point for every campaign fetch. Remembers the filter params
  // so handlePageChange can replay them, and always sends page/page_size.
  fetchHistory = (params, page = 1, pageSize = this.state.pageSize) => {
    this.lastQueryParams = params;
    this.receivedHistory = false;
    this.props.getSMSHistory({ ...params, page, page_size: pageSize });
  };

  handlePageChange = (newPage, pageSize) => {
    // Table gives a 0-based page; the API is 1-based.
    this.fetchHistory(this.lastQueryParams || {}, newPage + 1, pageSize);
  };

  handlePageSizeChange = (page, newPageSize) => {
    this.fetchHistory(this.lastQueryParams || {}, 1, newPageSize);
  };

  componentWillReceiveProps(nextProps) {
    let {
      smsHistoryList,
      singleHistoryList,
      singleSmartHistoryList,
      trackCampaignRes,
      smsDetails,
    } = nextProps;
    // No `smsList.length == 0` condition here: with server-side paging the
    // list is non-empty whenever page 2+ arrives, and that guard would drop
    // every page after the first. `receivedHistory === false` is already the
    // one-shot latch, cleared in fetchHistory and set again below.
    if (this.receivedHistory === false && smsHistoryList) {
      if (smsHistoryList.success) {
        const smsList =
          smsHistoryList.data.list?.map((el) => ({ ...el, id: el.campaignId })) || [];
        const pagination = smsHistoryList.data.pagination || {};
        this.receivedHistory = true;
        this.orgSMSList = smsList;
        // SMS Type filtering is now applied server-side via getSMSHistory's
        // message_type_filter — the returned list is already filtered, so no
        // client-side messageType filter here.
        this.setState({
          smsList,
          excelData: this.makeExcelData(smsList),
          // totalItems is the count across ALL pages; falling back to the row
          // count is what made the table read "1-50 of 50".
          totalCount: pagination.totalItems || smsList.length,
          currentPage: (pagination.page || 1) - 1,
          pageSize: pagination.pageSize || this.state.pageSize,
        });
      } else if (smsHistoryList.err) {
        alert(smsHistoryList.err.msg);
        this.receivedHistory = true;
      } else {
        this.receivedHistory = true;
      }
    }
    if (!this.receiveSingleHistory && singleHistoryList) {
      if (singleHistoryList.success) {
        this.singleHistory = singleHistoryList.data;
        this.receiveSingleHistory = true;
        this.setState({ showAllContacts: true, showWait: false });
      } else if (singleHistoryList.err) {
        alert(singleHistoryList.err.msg);
        this.receiveSingleHistory = true;
        this.setState({ showWait: false });
      } else {
        this.receiveSingleHistory = true;
        this.setState({ showWait: false });
      }
    }
    if (!this.receiveSingleSmartHistory && singleSmartHistoryList) {
      if (singleSmartHistoryList.success) {
        this.singleSmartHistory = singleSmartHistoryList.data;
        this.receiveSingleSmartHistory = true;
        this.setState({ showAllSmartContacts: true, showWait: false });
      } else if (singleSmartHistoryList.err) {
        alert(singleSmartHistoryList.err.msg);
        this.receiveSingleSmartHistory = true;
        this.setState({ showWait: false });
      } else {
        this.receiveSingleSmartHistory = true;
        this.setState({ showWait: false });
      }
    }
    if (!this.receiveTrackCampaign && trackCampaignRes) {
      if (trackCampaignRes.success) {
        this.receiveTrackCampaign = true;
        this.setState({
          activeyTrackCampaign: trackCampaignRes.tracking,
          showTrackData: true,
        });
      } else if (trackCampaignRes.err) {
        alert(trackCampaignRes.err.msg);
        this.receiveTrackCampaign = true;
        this.setState({ showTrackData: false, anchorEl: null });
      } else {
        this.receiveTrackCampaign = true;
        this.setState({ showTrackData: false, anchorEl: null });
      }
    }
    if (this.receivedSMSDetails === false && smsDetails) {
      this.receivedSMSDetails = true;
      if (smsDetails.success) {
        this.setState({ smsDetails: smsDetails.data });
        const params = {
          endDate: moment().valueOf(),
          startDate: moment().subtract(1, "months").valueOf(),
          senderId: smsDetails.data.senderIds,
        };
        this.fetchHistory(params);
      } else if (smsDetails.err) {
        alert(smsDetails.err.msg);
      }
    }
  }
  showAllContacts = (id) => {
    this.receiveSingleHistory = false;
    this.setState({ showWait: true });
    this.props.getStatusSMSHistory(id);
    GAEventTracker({ category: "SMS-History", action: "Show Report" });
  };
  showAllContactsSmart = (id) => {
    this.receiveSingleSmartHistory = false;
    this.setState({ showWait: true });
    this.props.getSmartStatusSMSHistory(id);
    GAEventTracker({ category: "SMS-History", action: "Show Smart Report" });
  };
  showTrackCampaign = (event, data) => {
    event?.stopPropagation();
    this.activeTrackData = data;
    this.receiveTrackCampaign = false;
    this.setState({ anchorEl: event.currentTarget, showTrackData: false });
    //Needs to be check
    this.props.getTrackCampaignDelivery(data.id, {
      isSmartURL: data.url ? 1 : 0,
    });
    GAEventTracker({ category: "SMS-History", action: "Show Track Campaign" });
  };
  closeAllContacts = () => this.setState({ showAllContacts: false });
  closeAllSmartContacts = () => this.setState({ showAllSmartContacts: false });
  closeTrackCampaign = () =>
    this.setState({ anchorEl: null, showTrackData: false });
  downloadReport = (e, id) => {
    e?.stopPropagation();
    this.receiveReport = true;
    this.setState({ showWait: true });
    getSMSReportSync(id)
      .then((downloadUrl) => {
        const a = document.getElementById("download-report");
        a.href = downloadUrl;
        a.click();
        this.setState({ showWait: false });
        GAEventTracker({ category: "SMS-History", action: "Download History" });
      })
      .catch((e) => {
        if (e && e.msg) {
          alert(e.msg);
          this.setState({ showWait: false });
        } else {
          alert("Something went wrong!");
          this.setState({ showWait: false });
        }
      });
  };

  //'Delivered SMS Counts': data.deliveryUpdates.DELIVRD || 0,
  //  'Delivery Percentage': `${(data.deliveryUpdates.DELIVRD || 0)*100/data.smsCountByType.val} %`,

  makeExcelData = (smsList) =>
    smsList.map((data) => ({
      Date: formatTimestampMs(data.createdAt),
      "SMS Text": data.messageText,
      Header: data.senderId,
      "SMS Type": data.messageType,
      "Contacts Counts": data.submittedCount,
      "SMS Credits": data.totalCredits,
      "Smart Tracking URL": data.url,
    }));

  isSameDate(a, b) {
    return Math.abs(a - b) < 1000 * 3600 * 24 && a.day() === b.day();
  }

  applyFilter = (
    { smsType, startDate, endDate, mobileNo, senderIds },
    appliedFilter = true,
  ) => {
    this.filterApplied = appliedFilter;
    const params = {
      senderId: senderIds,
      smsType,
    };
    if (startDate || endDate) {
      if (startDate === "") {
        alert("Please provide start date!");
        return;
      } else if (endDate === "") {
        alert("Please provide end date!");
        return;
      } else {
        const sDate = startDate.startOf("day").valueOf();
        const eDate = endDate.endOf("day").valueOf();
        if (sDate > eDate) {
          alert(
            "Start Date is greater than End Date, Please provide start date less than or equal to end Date",
          );
          return;
        } else {
          params.startDate = sDate;
          params.endDate = eDate;
        }
      }
    }
    if (mobileNo) {
      let numRegex = new RegExp("^[3-9][0-9]{9}$");
      if (numRegex.test(mobileNo)) {
        params.mobileNo = mobileNo;
      } else {
        alert("Mobile Number is invalid, Please provide correct mobile number");
        return;
      }
    }
    if (senderIds.length === 0) {
      alert("Please choose atleast one Header");
      return;
    }
    this.smsTypeFilter = smsType;
    // A new filter is a new result set — back to page 1.
    this.setState({ smsList: [], excelData: [], currentPage: 0, totalCount: 0 });
    this.orgSMSList = [];
    this.fetchHistory(params);
  };

  render() {
    let {
      showAllContacts,
      smsList,
      showWait,
      showAllSmartContacts,
      activeyTrackCampaign,
      anchorEl,
      showTrackData,
      excelData,
      smsDetails,
      currentPage,
      pageSize,
      totalCount,
    } = this.state;
    const isMobile = window.isMobile();
    return (
      <>
        <div
          className="sms-parent-container"
          style={isMobile ? { padding: 8 } : {}}
        >
          {this.receivedSMSDetails && (
            <Filter
              applyFilter={this.applyFilter}
              excelData={excelData}
              smsDetails={smsDetails}
            />
          )}
          {this.orgSMSList.length ? (
            <div>
              {smsList.length ? (
                <>
                  <Table
                    column={[
                      {
                        name: "Date",
                        value: "createdAt",
                        style: { width: 120 },
                        cell: (val) => formatTimestampMs(val),
                      },
                      {
                        name: "SMS Text, Header",
                        value: "messageText",
                        // Fixed width + single line + ellipsis. A message with
                        // no spaces (e.g. '+'-encoded text from a legacy GET
                        // send) used to stretch this column off-screen and make
                        // the page scroll sideways. The full text is on hover.
                        // style: { width: 420, maxWidth: 420 },
                        cell: (val, row) => (
                          <>
                            <div
                              title={val}
                              // style={{
                              //   maxWidth: 420,
                              //   whiteSpace: "nowrap",
                              //   overflow: "hidden",
                              //   textOverflow: "ellipsis",
                              // }}
                            >
                              {val}
                            </div>
                            <div
                              style={{
                                fontSize: 10,
                                marginTop: 4,
                                color: "#3b3d3e"
                              }}
                            >
                              {row.senderId}
                            </div>
                          </>
                        )
                      },
                      {
                        name: "Credit",
                        value: "totalCredits",
                        style: {width: 75},
                        cell: (val, row) => (
                          <span>{val || row.totalCredits}</span>
                        )
                      },
                      {name: "Numbers", value: "submittedCount", style: {width: 92}},
                      {
                        name: "Track Campaign",
                        value: "deliveryUpdates",
                        style: {width: 140},
                        cell: (val, row) => (
                          <Tooltip title="Track Campaign">
                            <IconButton
                              aria-label="Track"
                              onClick={(e) => this.showTrackCampaign(e, row)}
                            >
                              <TrendingUp color="primary" />
                            </IconButton>
                          </Tooltip>
                        )
                      },
                      {
                        name: "Status/Download",
                        value: "status",
                        style: {width: 180},
                        cell: (val, row) =>
                          val == 0 ? (
                            "Pending"
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                gap: 8,
                                flexWrap: "wrap",
                              }}
                            >
                              {row.url && (
                                <>
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={() =>
                                      this.showAllContactsSmart(row.id)
                                    }
                                  >
                                    {isMobile
                                      ? "Tracking"
                                      : "Smart URL Tracking"}
                                  </Button>
                                  <Tooltip title="Download">
                                    <IconButton
                                      aria-label="Download"
                                      onClick={(e) =>
                                        this.downloadReport(e, row.id)
                                      }
                                    >
                                      <FileDownload color="primary" />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              )}

                              <Button
                                size="small"
                                variant="outlined"
                                onClick={() => this.showAllContacts(row.id)}
                              >
                                Show Status
                              </Button>
                              <Tooltip title="Download Report">
                                <IconButton
                                  aria-label="Download Report"
                                  onClick={(e) =>
                                    this.downloadReport(e, row.id)
                                  }
                                >
                                  <FileDownload color="primary" />
                                </IconButton>
                              </Tooltip>
                            </div>
                          ),
                      },
                    ]}
                    serialNumber
                    data={smsList}
                    showPagination
                    serverSidePagination
                    totalCount={totalCount}
                    currentPage={currentPage}
                    defaultPageSize={pageSize}
                    onPageChange={this.handlePageChange}
                    onPageSizeChange={this.handlePageSizeChange}
                  />
                  <a
                    href=""
                    id="download-report"
                    style={{ display: "none" }}
                  ></a>
                </>
              ) : (
                <p style={{fontSize: 16}}>
                  No SMS Reports found with applied filter, Please reset the
                  filter!
                </p>
              )}
            </div>
          ) : (
            <div>
              {this.receivedHistory ? (
                <p style={{padding: 50, fontSize: 16, color: "#333"}}>
                  {this.filterApplied
                    ? "No SMS Reports found with applied filter, Please reset the filter!"
                    : "Currently No SMS Reports Available, Please do send your first SMS!"}
                </p>
              ) : (
                <CircularProgress size={80} thickness={5} />
              )}
            </div>
          )}
        </div>
        {showAllContacts ? (
          <SmsReport
            singleHistory={this.singleHistory}
            closeAllContacts={this.closeAllContacts}
          />
        ) : null}
        {showAllSmartContacts ? (
          <SmartSmsReport
            singleHistory={this.singleSmartHistory}
            closeAllContacts={this.closeAllSmartContacts}
          />
        ) : null}
        {Boolean(anchorEl) && (
          <TrackCampaign
            showTrackData={showTrackData}
            anchorEl={anchorEl}
            deliveryUpdates={activeyTrackCampaign}
            activeTrackData={this.activeTrackData}
            closeTrackCampaign={this.closeTrackCampaign}
          />
        )}
        {showWait ? (
          <Dialog open={showWait}>
            <DialogContent>
              <CircularProgress />
            </DialogContent>
          </Dialog>
        ) : null}
      </>
    );
  }
}
function mapStateToProps(state) {
  return {
    smsHistoryList: state.smsHistory.getHistoryResponse,
    singleHistoryList: state.smsHistory.getSingleHistoryResponse,
    singleSmartHistoryList: state.smsHistory.getSingleSmartHistoryResponse,
    trackCampaignRes: state.smsHistory.getTrackCampaignResponse,
    smsDetails: state.smsResponse.smsDetailsResponse
  };
}
export default connect(mapStateToProps, {
  getSMSHistory,
  getStatusSMSHistory,
  getTrackCampaignDelivery,
  getSmartStatusSMSHistory,
  getSMSDetails
})(SmsHistory);
